import React from 'react';
export interface Dream {
  id: string;
  content: string;
  date: string;
  rotation: number;
}
interface DreamCardProps {
  dream: Dream;
  onClick: (dream: Dream) => void;
}
export function DreamCard({
  dream,
  onClick
}: DreamCardProps) {
  return <article onClick={() => onClick(dream)} className="relative group cursor-pointer transition-all duration-300 ease-out hover:-translate-y-2 hover:z-10" style={{
    transform: `rotate(${dream.rotation}deg)`
  }} data-id="element-11">
      {/* Tape effect (optional, purely decorative) */}
      <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-16 h-8 bg-[#ffffff] opacity-40 rotate-1 shadow-sm z-20 pointer-events-none" data-id="element-12" />

      <div className="bg-[#fffef9] p-6 pb-8 shadow-md hover:shadow-xl transition-shadow duration-300 torn-bottom min-h-[280px] flex flex-col relative overflow-hidden" data-id="element-13">
        {/* Paper texture overlay */}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-repeat" style={{
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.5'/%3E%3C/svg%3E\")"
      }} data-id="element-14" />

        <div className="flex justify-between items-start mb-4 opacity-60" data-id="element-15">
          <span className="font-serif text-sm italic text-[#8b7355]" data-id="element-16">
            {dream.date}
          </span>
        </div>

        <p className="font-handwriting text-2xl leading-relaxed text-[#5c4033] line-clamp-6 flex-grow" data-id="element-17">
          {dream.content}
        </p>
      </div>
    </article>;
}